import Check from "./Check";
import Input from "./Input";
import Phone from "./Phone";
import Select from "./Select";
import Text from "./Text";
import TextArea from "./TextArea";
import Number from "./Number";

const keys = {
  Texto: Input,
  "Area de texto": TextArea,
  Número: Number,
  Celular: Phone,
  Correo: Input,
  Opciones: Input,
  Desplegable: Select,
  Check,
  Párrafo: Text,
};
export { keys };
